import { EditorView } from '@uiw/react-codemirror';
import { isUnsupportedQuery, themeObject } from '../../lib';

export const tqlEditorPageStyles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        p: '16px 24px 16px 24px',
        height: '100%',
    },
    titleAndHideButtonContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    titleContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    titleText: {
        fontFamily: 'Raleway',
        fontSize: '28px',
        fontWeight: 600,
        lineHeight: '32.87px',
        color: themeObject.palette.primary[700],
        mr: '4px',
    },
    collapsedTitleAndAddButtonContainer: {
        mb: 3,
    },
    titleAndAddButtonContainer: {
        mb: 1.5,
    },
    tabsContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        overflow: 'hidden',
        mb: 1,
    },
    tabs: {
        height: '36px',
        minHeight: 0,
        textAlign: 'center',
        alignItems: 'center',
    },
    tabItemStyles: {
        minHeight: '0',
        m: '6px !important',
    },
    selectFieldStyles: {
        width: '220px',
        height: '40px',
    },
    selectFieldHeightStyles: {
        maxHeight: '240px',
    },
    arrowDownIcon: {
        color: themeObject.palette.primary.dark,
        fontSize: '18px',
    },
    filterButton: {
        width: '67px',
        height: '30px',
        ml: 1.5,
    },
    filterButtonText: {
        color: themeObject.palette.primary[700],
        fontFamily: 'Red Hat Text',
        fontWeight: 700,
        fontSize: '14px',
        lineHeight: '22px',
    },
    filterIcon: {
        width: '20px',
        height: '20px',
    },
    filterTitleContainer: {
        display: 'flex',
        alignItems: 'center',
        mr: 2,
    },
    filterTitle: {
        color: themeObject.palette.primary[700],
        fontWeight: '500',
        fontFamily: 'Raleway',
        fontSize: '20px',
        lineHeight: '23.48px',
        ml: 0.5,
    },
    runButton: {
        width: '110px',
        mr: 1.5,
    },
    historyButton: {
        width: '110px',
    },
    buttonIcon: {
        color: themeObject.palette.primary[600],
    },
    collapsableContainer: {
        width: '100%',
        mt: 1.5,
        '& .MuiCollapse-wrapper': {
            height: '100%',
            '& .MuiCollapse-wrapperInner': {
                height: '100%',
            },
        },
    },
    tqlEditorPanel: {
        marginBottom: '24px',
    },
    resultsPanel: {
        marginTop: '12px',
    },
    panelContainerBaseStyles: {
        position: 'relative',
    },
    visibleEmptyPanelContainerStyles: {
        '&:before': {
            content: '""',
            height: '4.5px',
            width: '55px',
            backgroundColor: themeObject.palette.grayScale[300],
            position: 'absolute',
            transform: 'translateX(-50%)',
            left: '50%',
            top: '5px',
        },
        '&:after': {
            content: '""',
            backgroundColor: themeObject.palette.grayScale[300],
            position: 'absolute',
            transform: 'translateX(-50%)',
            left: '50%',
            top: '-2px',
            height: '4.5px',
            width: '55px',
        },
    },
    visiblePanelContainerStyles: {
        '&:before': {
            content: '""',
            height: '4.5px',
            width: '55px',
            backgroundColor: themeObject.palette.grayScale[300],
            position: 'absolute',
            transform: 'translateX(-50%)',
            left: '50%',
            top: '-6px',
        },
        '&:after': {
            content: '""',
            backgroundColor: themeObject.palette.grayScale[300],
            position: 'absolute',
            transform: 'translateX(-50%)',
            left: '50%',
            top: '-13px',
            height: '4.5px',
            width: '55px',
        },
    },
    paper: {
        p: 1,
        border: `1px solid ${themeObject.palette.grayScale[300]} `,
        borderRadius: '8px',
        boxShadow: 'none',
        height: 'calc(100% - 75px)',
        marginTop: '12px',
        width: 'calc(100% - 20px);',
        display: 'flex',
        justifyContent: 'center',
    },
    downloadIconContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        '& .download-icon': {
            height: '24px',
            width: '24px',
        },
    },
    emptyCustomTQLPanel: {
        height: '100%',
        overflow: 'hidden',
    },
    populatedCustomTQLPanel: {
        height: 'calc(100% - 50px)',
        overflow: 'auto',
    },
};

export const tqlEditorStyles = {
    tqlEditorInnerContainer: {
        display: 'flex',
        height: '100%',
        width: '100%',
    },
    tqlEditor: {
        height: '100%',
        width: '100%',
    },
};

export const tqlResultsEmptyStateStyles = {
    emptyStateContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
    emptyStateTitleText: {
        ...themeObject.typography.h2,
        fontSize: '26px',
        color: themeObject.palette.primary[700],
        mb: 2,
    },
    emptyStateBodyText: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.regular,
        color: themeObject.palette.grayScale[700],
    },
};

export const TQLEditorStyles = EditorView.baseTheme({
    '.cm-scroller': {
        borderRadius: '12px',
        '&::-webkit-scrollbar': { width: '8px', height: '8px' },
        '&::-webkit-scrollbar-track': {
            display: 'none',
            borderRadius: '12px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: themeObject.palette.primary[500],
            borderRadius: '12px',
        },
    },
    '&.cm-editor': {
        borderRadius: '12px',
        width: '100%',
        height: '100%',
    },
    '&.cm-editor.cm-focused': {
        borderRadius: '12px',
        width: '100%',
        height: '100%',
    },
});

export const tqlHistoryDrawerStyles = {
    drawer: {
        width: '570px',
        '& .MuiPaper-root': {
            '& .drawer-content': {
                padding: '8px 4px',
                scrollbarColor: 'initial',
                scrollbarWidth: 'initial',
            },
        },
    },
    accordionContainer: {
        width: '510px',
    },
    title: {
        ...themeObject.typography.h3,
        color: `${themeObject.palette.primary[700]}`,
        fontVariantNumeric: 'lining-nums',
    },
    fieldWidth: {
        width: '100%',
    },
    accordionDetailsStyles: {
        p: '0px 16px 12px 16px',
    },
    accordionDetailsContainerStyles: {
        gap: '10px',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    contentContainerStyles: {
        border: `1px solid ${themeObject.palette.grayScale[500]}`,
        borderRadius: '4px',
        p: '12px 24px 18px 12px',
        overflowY: 'auto',
        maxHeight: '375px',
    },
    queryTextStyles: {
        ...themeObject.typography.body.regular,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.default,
        color: themeObject.palette.grayScale[700],
        lineHeight: '100%',
    },
    buttonContainerStyles: {
        display: 'flex',
        justifyContent: 'end',
    },
    buttonStyles: {
        width: '125px',
        height: '30px',
        fontSize: '14px',
    },
    emptyStateContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '325px',
        mt: 40.8125,
        mb: 48.3125,
        mx: 11.5,
    },
    emptyStateTitleText: {
        color: themeObject.palette.primary[700],
        ...themeObject.typography.h2,
        fontSize: '26px',
        mb: 2,
    },
    emptyStateBodyText: {
        ...themeObject.typography.body.regular,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.default,
        color: themeObject.palette.grayScale[700],
        textAlign: 'center',
    },
};

export const TQL_EDITOR_PANELS = {
    EDITOR_PANEL: {
        ORDER: 1,
        DEFAULT_SIZE: 40,
        MAX_SIZE: 60,
        MIN_SIZE: 30,
        COLLAPSED_SIZE: 0,
    },
    RESULTS_PANEL: {
        ORDER: 2,
        DEFAULT_SIZE: 70,
        MAX_SIZE: 90,
        MIN_SIZE: 10,
    },
};

export const TQL_EDITOR_TAB_VALUES = {
    JSON_TAB: {
        index: 0,
        label: 'JSON',
        aria_label: 'TQL Editor JSON Result Tab',
    },
    TABLE_TAB: {
        index: 1,
        label: 'Table',
        aria_label: 'TQL Editor Table Result Tab',
    },
};

export const TQL_HISTORY_QUERY_KEY = 'tql-history-queries';

export const isUnsupportedTQLQuery = (query: string): boolean => {
    const unsupportedKeywords = [
        'GRAPH',
        'GRAPH PATHS',
        'GRAPH MAPPABLE',
        'GRAPH MAPPABLE PATHS',
    ];
    return isUnsupportedQuery(query, unsupportedKeywords);
};
